const MS_PER_DAY = 24 * 60 * 60 * 1000

const getPhaseWindow = (previewScheduleData, phaseType) => {
  const phases = previewScheduleData?.[0]?.phases
  if (!phases) return null

  const phase = phases.find(p => p.phase_type_code === phaseType)
  if (!phase) return null

  const start = new Date(phase.est_started_at)
  const end = new Date(start)
  end.setDate(end.getDate() + (parseInt(phase.est_duration) || 14))

  return { start, end }
}

export const calcMaxSafeSuccessions = ({ previewScheduleData, frostDates, intervalDays, growthType }) => {
  const ffd = frostDates?.ffd
  if (!ffd || !intervalDays || intervalDays <= 0) return null

  const window = getPhaseWindow(previewScheduleData, 'mature')
  if (!window) return null

  // For indeterminate, mature end is already clamped to frost — use mature start instead
  const referenceDate = growthType === 'indeterminate' ? window.start : window.end
  const daysToFfd = (new Date(ffd) - referenceDate) / MS_PER_DAY

  return Math.max(0, Math.floor(daysToFfd / intervalDays))
}

export const useHarvestFrostWarning = ({ previewScheduleData, frostDates, successions, growthType }) => {
  const ffd = frostDates?.ffd
  if (!ffd) return null

  const maturingWindow = getPhaseWindow(previewScheduleData, 'maturing')
  const matureWindow = getPhaseWindow(previewScheduleData, 'mature')
  if (!maturingWindow || !matureWindow) return null

  const ffdDate = new Date(ffd)

  // const lfd = frostDates?.lfd
  // if (lfd) {
  //   // Normalize both to local-calendar midnight before comparing — phase dates are UTC ISO strings
  //   // while lfd comes from doyToJSDate (local midnight), so sub-day timezone differences can
  //   // cause false negatives/positives without this normalization.
  //   const toLocalMidnight = (date) => {
  //     const d = new Date(date)
  //     d.setHours(0, 0, 0, 0)
  //     return d.getTime()
  //   }
  //   const daysAfterLFD = (toLocalMidnight(maturingWindow.start) - toLocalMidnight(lfd)) / MS_PER_DAY
  //   if (daysAfterLFD < 0) {
  //     return { severity: 'error', message: 'Maturing phase starts before the last spring frost, risk of frost damage!' }
  //   }
  //   if (daysAfterLFD < 14) {
  //     return { severity: 'warning', message: 'Maturing phase starts within 2 weeks of the last spring frost, monitor for late frosts!' }
  //   }
  // }

  const successionOffset =
    successions?.enabled && (successions?.count ?? 0) > 0 && (successions?.intervalDays ?? 0) > 0
      ? successions.count * successions.intervalDays * 24 * 60 * 60 * 1000
      : 0 // fallback to 0, no successions

  const maturingEnd = successionOffset ? new Date(maturingWindow.end.getTime() + successionOffset) : maturingWindow.end

  if (maturingEnd > ffdDate) {
    return { severity: 'error', message: 'Harvest window trails the fall first frost, maturity at risk!' }
  }

  if (growthType === 'indeterminate') {
    // For indeterminate, mature always ends at frost — warn if the last succession's harvest window is < 2 weeks
    const lastMatureStart = new Date(matureWindow.start.getTime() + successionOffset)
    const harvestWindowDays = (ffdDate - lastMatureStart) / MS_PER_DAY
    if (harvestWindowDays < 14) {
      return { severity: 'warning', message: 'Indeterminate harvest window is less than 2 weeks from the first fall frost, be vigilant!' }
    }
  } else {
    const matureEnd = successionOffset ? new Date(matureWindow.end.getTime() + successionOffset) : matureWindow.end
    if (matureEnd > ffdDate) {
      return { severity: 'warning', message: 'Harvest window overlaps the first fall frost, be vigilant!' }
    }
  }

  return null
}
